import * as React from 'react'

export const StarIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.6875 0.40625L11.9688 4.90625L16.9688 5.71875C17.25 5.75 17.4688 5.9375 17.5625 6.21875C17.6562 6.5 17.5938 6.78125 17.375 6.96875L13.8125 10.5625L14.5938 15.5625C14.625 15.8438 14.5312 16.125 14.2812 16.2812C14.0625 16.4375 13.75 16.4688 13.5 16.3438L9 14.0625L4.5 16.3438C4.25 16.4688 3.9375 16.4375 3.71875 16.2812C3.46875 16.125 3.375 15.8438 3.40625 15.5625L4.1875 10.5625L0.625 6.96875C0.4375 6.78125 0.34375 6.5 0.4375 6.21875C0.53125 5.9375 0.75 5.75 1.03125 5.71875L6.03125 4.90625L8.34375 0.40625C8.46875 0.15625 8.71875 0 9 0C9.28125 0 9.53125 0.15625 9.6875 0.40625Z"
        fill="currentColor"
      />
    </svg>
  )
}
